<div class="flex flex-col w-full dialog-content" id="data-pull-modal">
  <div class="px-6 pt-6 pb-4 flex flex-col w-full bg-white">
    <span class="text-lg font-inter font-bold text-black-800">
      {{ data.headerText }}
    </span>
    <span class="text-sm font-inter pt-2 text-black-800">
      {{ data.description }}
    </span>
    <div *ngIf="data.showWarning" class="flex items-center text-sm font-inter text-red-500 pt-2">
      <mat-icon role="img" class="text-lg -mt-1 ml-2 text-red-500" aria-hidden="true" data-mat-icon-type="font">
        warning
      </mat-icon>
      <span class="ml-2">Birth dates may not actually be the first of the month. Please verify with the client.</span>
    </div>
<!--    <span class="flex text-red-600 text-sm font-inter">-->
<!--      <img class="mr-2 -mt-1" src="assets/icons/warning.svg" alt="warning"> We found the following info based on the-->
<!--      data you provided. Please confirm all the data is correct before adding a form.-->
<!--    </span>-->
  </div>
  <div class="flex flex-col w-full font-inter overflow-y-auto p-6 bg-gray-20">
    <xilo-accordion class="flex flex-col rounded bg-white mt-2 " *ngFor="let section of sections">
      <xilo-accordion-panel [open]="true">
        <xilo-accordion-title [noBorder]="true" paddingClass="p-3">
          <div *ngIf="section.values.length > 1">
            {{ section.key }} <span class="text-gray-400">({{ section.values.length }})</span>
          </div>
          <div *ngIf="section.values.length === 1">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              [(ngModel)]="section.values[0].isValid"
              (change)="selectAll(section.values[0], $event.checked)"
            ></mat-checkbox>
            {{ section.key }}
          </div>
        </xilo-accordion-title>
        <xilo-accordion-content paddingClass="py-0">
          <ng-container *ngIf="section.values.length === 1">
            <div class="pl-5 pr-4 pb-4 grid grid-cols-2 lg:grid-cols-4 gap-4">
              <ng-container *ngFor="let item of section.values[0].values">
                <div class="field-item">
                  <div [class.field-deleted]="!item.isValid" class="text-gray-400 font-inter text-sm">
                    {{ item.label }}
                  </div>
                  <div class="font-inter text-sm value">
                    <span [class.field-deleted]="!item.isValid">{{ item.value }}</span>
                    <mat-icon *ngIf="item.isValid" class="text-lg ml-1 -mt-1 add-remove-item pointer" (click)="removeItem(item, section.values[0])">
                      close
                    </mat-icon>
                    <mat-icon *ngIf="!item.isValid" class="text-lg ml-1 -mt-1 add-remove-item pointer" (click)="addItem(item, section.values[0])">
                      add
                    </mat-icon>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="section.values.length > 1">
            <xilo-accordion-panel *ngFor="let group of section.values" [open]="group.isOpen">
              <xilo-accordion-title paddingClass="py-1 pr-4 pl-1">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  [(ngModel)]="group.isValid"
                  (change)="selectAll(group, $event.checked)"
                ></mat-checkbox>
                {{ group | pullDataGroupTitle }}
              </xilo-accordion-title>
              <xilo-accordion-content paddingClass="px-4 pb-3">
                <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
                  <ng-container *ngFor="let item of group.values">
                    <div class="field-item">
                      <div [class.field-deleted]="!item.isValid" class="text-gray-400 font-inter text-sm">
                        {{ item.label }}
                      </div>
                      <div class="font-inter text-sm value">
                        <span [class.field-deleted]="!item.isValid">{{ item.value }}</span>
                        <mat-icon *ngIf="item.isValid" class="text-lg ml-1 -mt-1 add-remove-item pointer" (click)="removeItem(item, group)">
                          close
                        </mat-icon>
                        <mat-icon *ngIf="!item.isValid" class="text-lg ml-1 -mt-1 add-remove-item pointer" (click)="addItem(item, group)">
                          add
                        </mat-icon>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="duplicate-container flex flex-row p-2 rounded mt-2" *ngIf="group.duplicateIndex >= 0">
                  <div class="icon w-1/10 mt-1 mr-1">
                    <ng-container *ngIf="group.isDuplicate">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.3335 8.00033L6.66683 11.3337L13.3335 4.66699" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="!group.isDuplicate">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.3334 12.3337L9.66675 9.66699M11.0001 6.33366C11.0001 8.91099 8.91074 11.0003 6.33341 11.0003C3.75609 11.0003 1.66675 8.91099 1.66675 6.33366C1.66675 3.75633 3.75609 1.66699 6.33341 1.66699C8.91074 1.66699 11.0001 3.75633 11.0001 6.33366Z" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </ng-container>
                  </div>
                  <div class="duplicate-content w-9/10">
                    <div class="duplicate-content__title font-semibold" *ngIf="!group.isDuplicate">Duplicate Found</div>
                    <div class="duplicate-content__title font-semibold" *ngIf="group.isDuplicate">Merging Record</div>
                    <div class="duplicate-content__description">
                      <span *ngIf="!group.isDuplicate">We noticed this row may already exist. Do you want to merge it into the existing row or unselect it?</span>
                      <span *ngIf="group.isDuplicate">This record will be merged into the existing one was you submit this information!</span>
                      <div class="duplicate-content__actions mt-2">
                        <button [disabled]="group.isDuplicate" class="duplicate-content__btn mr-2" (click)="mergeDuplicateRecord(group)">Merge Record</button>
                        <button class="duplicate-content__btn secondary-btn" (click)="unselectRecord(group)">Unselect Record</button>
                      </div>
                    </div>
                  </div>
                </div>
              </xilo-accordion-content>
            </xilo-accordion-panel>
          </ng-container>
        </xilo-accordion-content>
      </xilo-accordion-panel>
    </xilo-accordion>
  </div>
  <div class="flex px-6 py-4">
    <button (click)="closeModal()" xilo-button size="large" color="primary-border">
      <span class="text-sm">Cancel</span>
    </button>
    <button
      id="data-pull-add-btn"
      xilo-button
      class="ml-auto"
      size="large"
      color="primary"
      (click)="saveData()"
    >
      <span class="text-sm">Submit this information</span>
    </button>
  </div>
</div>
